import Shake from 'shake.js'

export const ShakeEvent = new Shake({ threshold: 15, timeout: 1000 })

export const shakeListener = searchFunction => {
  window.addEventListener('shake', searchFunction, false)
}

export const stopTheShake = searchFunction => {
  window.removeEventListener('shake', searchFunction, false)
  ShakeEvent.stop()
}

const vibrateEnabled =
  window.navigator.vibrate ||
  window.navigator.webkitVibrate ||
  window.navigator.mozVibrate ||
  window.navigator.msVibrate

export const vibrateDevice = vibrateCount => {
  if (vibrateEnabled) {
    window.navigator.vibrate(vibrateCount)
  }
  return
}



// WEBPACK FOOTER //
// ./src/components/Elements/DeviceEvents/ShakeSearch/ShakeComponent/Factory.js